.image {
  display: block;
  width: 100%;
  height: auto;
  max-width: 100%;
  object-fit: contain;
  vertical-align: middle;
}

.fixedWidth {
  width: auto;
  max-width: 100%;
}
